import React from 'react'

import { Portlet } from '_zari/core'

import { CodigosTransaccionesConstant } from 'constants/index'

import { IdGen } from 'utils'

import MainForm from './mainForm'

const portletBreadcrumbs = [
  {
    name: 'Asientos Contables',
    path: `/${CodigosTransaccionesConstant.ASIENTOSCONTABLES_LISTA}`
  },
  { name: `Origen CANJE LETRAS` }
]

const NuevoOgCanje = () => {
  const [_mainFormKey, setMainFormKey] = React.useState(IdGen.newId())

  const resetMainForm = React.useCallback(() => {
    setMainFormKey(IdGen.newId())
  }, [])

  return (
    <Portlet>
      <Portlet.Header title='Asientos Contables' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        <MainForm key={_mainFormKey} resetMainForm={resetMainForm} />
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(NuevoOgCanje)
